import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { requestUpdateUserInfo } from "../../../../../redux/actions/user";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import { Input } from "../../../../library/input";
import { Label } from "../../../../library/label";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const authLoading = useSelector(
    (state) => state.user.fetchUserDetails.loading
  );
  const updateLoading = useSelector((state) => state.user.updateInfo.loading);
  const userInfo = useSelector((state) => state.user.details);
  const [editInfo, setEditInfo] = useState({});

  useEffect(() => {
    if (Object.keys(editInfo).length === 0 && userInfo.firstName) {
      const editObject = {
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        mobile: userInfo.mobile,
      };
      setEditInfo(editObject);
    }
  }, [userInfo]);

  const clickSave = () => {
    if (editInfo.firstName && editInfo.lastName) {
      dispatch(
        requestUpdateUserInfo({
          type: "short",
          info: {
            firstName: editInfo.firstName,
            lastName: editInfo.lastName,
            mobile: editInfo.mobile
              ? parseInt(editInfo.mobile.toString().replace(/ /g, ""))
              : null,
          },
          user: userInfo.id,
        })
      );
    } else {
      sendErrorNotification("Vennligst fyll inn alle felt.");
    }
  };

  return (
    <div>
      <div className="account-left-information-container">
        <h3>Kontoinformasjon</h3>
        <div className="single-information-container">
          <Label version={1} weight="bold">
            Fornavn
          </Label>
          {authLoading && (
            <i className="fas fa-circle-notch fa-spin input-loader"></i>
          )}
          <Input
            value={editInfo.firstName}
            onChange={(e) =>
              setEditInfo({ ...editInfo, firstName: e.target.value })
            }
            type="text"
            placeholder={editInfo.firstName && !authLoading && "Fornavn"}
          />
        </div>
        <div className="single-information-container">
          <Label version={1} weight="bold">
            Etternavn
          </Label>
          {authLoading && (
            <i className="fas fa-circle-notch fa-spin input-loader"></i>
          )}
          <Input
            value={editInfo.lastName}
            onChange={(e) =>
              setEditInfo({ ...editInfo, lastName: e.target.value })
            }
            type="text"
            placeholder={!editInfo.lastName && !authLoading && "Etternavn"}
          />
        </div>
        <div className="single-information-container">
          <Label version={1} weight="bold">
            Mobil
          </Label>
          {authLoading && (
            <i className="fas fa-circle-notch fa-spin input-loader"></i>
          )}
          <Input
            format="phone"
            value={editInfo.mobile}
            onChange={(e) =>
              setEditInfo({ ...editInfo, mobile: e.target.value })
            }
            placeholder={!editInfo.mobile && !authLoading && "Ditt mobilnummer"}
            type="text"
          />
        </div>
      </div>
      <Row className="account-left-bottom-row">
        <Col md={6} className="info-col text-left my-auto">
          <p className="information-label">
            <i className="fas fa-exclamation-circle"></i> Fyll inn alle felt
            over.
          </p>
        </Col>
        <Col md={6} className="button-col text-right my-auto">
          <button onClick={() => clickSave()} className="save-button">
            {updateLoading && <i className="fas fa-circle-notch fa-spin"></i>}{" "}
            {updateLoading ? "Lagrer endringer.." : "Lagre endringer"}
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default Index;
